import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InBaseFrwComponent} from '../inBaseFrwComponent';
import {TYPE} from '../../models/type.enum';

@Component({
  selector: 'cmp-action-buttons',
  template: `<div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
  <ng-template  ngFor let-item let-i="index" [ngForOf]="arrayButton">
    <button type="button"
            class="btn border "
            [class]="inClass(item)"
            (click)="actionActive(item)">{{item}}</button>
  </ng-template>
</div>
`,
  styles: [``]
})
export class ActionButtonsComponent extends InBaseFrwComponent implements OnInit {

  @Input() arrayButton = [];
  @Input() active: any;
  @Output() activeChange = new EventEmitter();
  @Input() typeButtonActive: TYPE = TYPE.SUCCESS;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  actionActive(item) {
    this.active = item;
    this.activeChange.emit(this.active);
  }

  inClass(item) {
    let retorno = 'btn border ';
    if (item !== this.active) {
      retorno += ` btn-outline-${this.typeButtonActive}`;
    }
    if (item === this.active) {
      retorno += `btn-${this.typeButtonActive} btn-lg active`;
    }
    return retorno;
  }
}
